import { guidEmpty } from 'utils/guid-empty';

export class PessoaParametroRequestModel {
  constructor(
    public id: string = guidEmpty(),
    public pessoaId: string = guidEmpty(),
    public parametroId: string = guidEmpty(),
    public valor: string = '',
  ) {}
}
